import React, { PureComponent } from 'react'
import track from 'react-tracking'
import { reduxForm, formValues } from 'redux-form'
import Field from '@ynap/field'
import { SimpleAsyncButton } from '@ynap/button'
import Notification from '@ynap/notification'
import validate from './validate'
import { parse } from 'query-string'
import { Link } from 'react-router-dom'
import { onSubmitFail } from '@ynap/form-utils'
import BEMHelper from '@ynap/bem-helper'
import { Panel } from '@ynap/login-and-registration-form'
import { myaccountPageData } from '../analytics'

const bem = new BEMHelper('Unsubscribe')

@track()
export class Unsubscribe extends PureComponent {
    constructor() {
        super()
        this.submit = this.submit.bind(this)
    }

    @track(
        myaccountPageData({
            name: 'unsubscribe email',
            type: 'unsubscribe email'
        })
    )
    componentDidMount() {}

    submit(values) {
        const { updateSubscriptions } = this.props
        const { validationCode } = parse(window?.location?.search)

        return updateSubscriptions({ maMarketingEmailStandard: false }, { accessKey: validationCode, email: values.logonId })
    }

    render() {
        const { form, messages, submitFailed, handleSubmit, submitSucceeded, locale, submitting } = this.props

        return(
            <div className={bem()} >
                {!submitSucceeded ? (
                    <Panel title={messages.unsubscribe.title()}>
                        <form id={form} className={bem('form')} onSubmit={handleSubmit(this.submit)}>
                            <Field name="logonId" type="email" label={messages.unsubscribe.logonId()} autoComplete="username" />
                            {submitFailed && !submitting ? <Notification className={bem('error')} message={messages.errors.generic()} type="error" /> : null}
                            <SimpleAsyncButton className={bem('submit')} loading={submitting} copy={messages.unsubscribe.submit()} />
                        </form>
                    </Panel>
                ) : (
                    <Panel title={messages.unsubscribe.confirmation()}>
                        <div className={bem('confirmationContainer')}>
                            <div className={bem('unsubscribeSuccess')}>{messages.unsubscribe.unsubscribeSuccess()}</div>
                            <Link className={bem('shop')} to={`/${locale.id}/shop/just-in`}>
                                {messages.unsubscribe.continue()}
                            </Link>
                        </div>
                    </Panel>
                )}
            </div>
        )
    }
}

const UnsubscribeWithValues = formValues('logonId')(Unsubscribe)
export default reduxForm({ form: 'unsubscribe', validate, onSubmitFail })(UnsubscribeWithValues)
